import { InternalEventWait, TourWait } from "@app/component/flows/types/TourDescriptor";

export const isInternalWaitEvent = (event: TourWait): event is InternalEventWait =>
  event.eventType === "internal";
